<template>

  <div>

    <div :id="componentId" class="ui large modal sales-order-modal">

      <div class="ui header">
        Visualização de Pedido de Vendas
      </div>

      <div class="content modal-content-scrolling">

        <div v-if="loading"><i class="spinner circle loading blue icon"></i> Carregando ...</div>

        <div v-if="!loading && order" class="animated fadeIn">

          <form class="ui form">
            <div class="fields">
              <div class="three wide field">
                <label class="form-label">Status</label>
                <span>
                  <i class="icon" :class="order.iconStatus + ' ' + order.colorStatus"></i> 
                  {{ order.status }}
                </span>
              </div>
              <div class="three wide field">
                <label class="form-label">Filial</label>
                <span>{{ branchId + ' - ' + $branchName(order.branch) }}</span>
              </div>
              <div class="two wide field">
                <label class="form-label">Número</label>
                <span>{{ orderId }}</span>
              </div>
              <div class="two wide field">
                <label class="form-label">Emissão</label>
                <span>{{ $formatDate(order.date) }}</span>
              </div>
              <div class="two wide field">
                <label class="form-label">Produção</label>
                <span>{{ $formatDate(order.deliveryDate) }}</span>
              </div>
              <div class="four wide field">
                <label class="form-label">V. Pedido</label>
                <span>R$ {{ $formatCurrency(order.total) }}</span>
              </div>
              <div class="four wide field">
                <label class="form-label">V.Empenhado</label>
                <span>R$ {{ $formatCurrency(order.valEmp) }}</span>
              </div>
              <div class="four wide field">
                <label class="form-label">V.Faturado</label>
                <span>R$ {{ $formatCurrency(order.ValFat) }}</span>
              </div>
              <div class="four wide field">
                <label class="form-label">V.Saldo</label>
                <span>R$ {{ $formatCurrency(order.total - order.ValFat) }}</span>
              </div>
            </div>
            <div class="fields">
              <div class="sixteen wide field">
                <label class="form-label">Cliente</label>
                <span>{{ order.nameCustomer }}</span>
              </div>          
            </div>        
          </form>

          <div class="ui secondary menu m-t-20">
            <a class="item" :class="{ active: (selectedItemsOption == 'products') }" @click="selectedItemsOption = 'products'">
              Produtos
            </a>
            <a class="item" :class="{ active: (selectedItemsOption == 'invoices') }" @click="selectedItemsOption = 'invoices'">
              Notas Fiscais
            </a>
            <a class="item" :class="{ active: (selectedItemsOption == 'quotation') }" @click="selectedItemsOption = 'quotation'">
              Orçamento
            </a>
          </div>

          <div v-if="selectedItemsOption == 'products'" class="ui segment animated fadeIn">
            <table class="ui very basic celled tablet stackable table">
              <thead class="desktop-only">
                <tr>
                  <th>Item</th>
                  <th>Produto</th>
                  <th>Lances</th>
                  <th>Quantidade</th>
                  <th>Preço</th>
                  <th>Valor Total</th>
                  <th>Qtd Empenhada</th>
                  <th>Qtd Faturada</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in order.items">
                  <td><strong class="mobile-only">Item: </strong>{{ item.item }}</td>
                  <td><strong class="mobile-only">Produto: </strong>{{ item.fullDescription }}</td>
                  <td><strong class="mobile-only">Lances: </strong>{{ item.lances }}</td>
                  <td><strong class="mobile-only">Quantidade: </strong>{{ $formatInteger(item.quantity) }}</td>
                  <td><strong class="mobile-only">Preço: </strong>{{ $formatCurrency(item.price) }}</td>
                  <td><strong class="mobile-only">Valor Total: </strong>{{ $formatCurrency(item.total) }}</td>
                  <td><strong class="mobile-only">Qtd Empenhada: </strong>{{ $formatInteger(item.empenhado) }}</td>
                  <td><strong class="mobile-only">Qtd Faturada: </strong>{{ $formatInteger(item.invoiceQuantity) }}</td>
                </tr>
              </tbody>
            </table>
          </div>    

          <div v-if="selectedItemsOption == 'invoices'" class="ui segment animated fadeIn">
            <table class="ui very basic celled selectable tablet stackable table">
              <thead class="desktop-only">
                <tr>
                  <th>Filial</th>
                  <th>Número</th>
                  <th>Série</th>
                  <th>Emissão</th>
                  <th>Entrega</th>
                  <th>Transportadora</th>
                  <th>Valor Total</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="invoice in invoices" class="clickable" @click="showInvoice(invoice)">
                  <td><strong class="mobile-only">Filial: </strong>{{ invoice.branch + ' - ' + $branchName(invoice.branch) }}</td>
                  <td><strong class="mobile-only">Número: </strong>{{ invoice.number }}</td>
                  <td><strong class="mobile-only">Série: </strong>{{ invoice.series }}</td>
                  <td><strong class="mobile-only">Emissão: </strong>{{ $formatDate(invoice.date) }}</td>
                  <td><strong class="mobile-only">Entrega: </strong>{{ $formatDate(invoice.deliveryDate) }}</td>
                  <td><strong class="mobile-only">Transportadora: </strong>{{ invoice.carrier }}</td>
                  <td><strong class="mobile-only">Valor Total: </strong>{{ $formatCurrency(invoice.total) }}</td>
                </tr>                   
              </tbody>
            </table>
          </div>

          <div v-if="selectedItemsOption == 'quotation'" class="ui segment animated fadeIn">
            <table class="ui very basic celled selectable tablet stackable table">
              <thead class="desktop-only">
                <tr>
                  <th>Número</th>
                  <th>Emissão</th>
                  <th>Data Processamento</th>                
                </tr>
              </thead>
              <tbody>
                <tr class="clickable" @click="showQuotation()">
                  <td><strong class="mobile-only">Número: </strong>{{ order.quotationId }}</td>
                  <td><strong class="mobile-only">Emissão: </strong>{{ $formatDate(order.dateQuotation) }}</td>
                  <td><strong class="mobile-only">Data Processamento: </strong>{{ $formatDate(order.dtProcQuotation) }}</td>                
                </tr>                   
              </tbody>
            </table>
          </div>

        </div>

      </div>

      <div class="actions">
        <button class="ui basic button" @click="hide()">
          <i class="reply icon"></i>
          Sair
        </button>      
      </div>

    </div>

    <invoice-dialog id="sales-order-invoice-dialog" ref="invoiceDialog" 
      :branchId="selectedInvoice.branch" :number="selectedInvoice.number" :series="selectedInvoice.series" />

  </div>

</template>

<script>

  import InvoiceDialog from "./invoice-dialog.vue"
  import { InvoiceService, SalesOrderService, QuotationService } from "@/services"

  export default {
    
    data() {
      return {
        componentId: "sales-order-dialog",
        loading: false,
        order: null,
        invoices: [],
        selectedItemsOption: "products",
        selectedInvoice: {},
      }
    },

    props: ["id", "branchId", "orderId"],

    watch: {

      "orderId" () {
        this.loadOrder()
      },
    },

    components: {
      InvoiceDialog,
    },

    created() {

      if (this.id)
        this.componentId = this.id
    },

    mounted() {

      $("#" + this.componentId).modal({ allowMultiple: true })
    },

    beforeDestroy() {
      $(".sales-order-modal").remove()
    },

    methods: {

      show() {        
        
        this.selectedItemsOption = "products"

        $("#" + this.componentId).modal("show")
      },

      hide() {
        $("#" + this.componentId).modal("hide")
      },

      async loadOrder() {

        this.loading = true

        try {

          this.order = await SalesOrderService.getById(this.branchId, this.orderId)
          this.invoices = await InvoiceService.getOrderInvoices(this.branchId, this.orderId)
          
          this.loading = false
          
        } catch (error) {
          
          this.loading = false
          this.$errorHandler(error)
        }
      },

      showInvoice(invoice) {

        this.selectedInvoice = invoice

        this.$refs.invoiceDialog.show()
      },

      showQuotation() {
        QuotationService.showQuotation(this.order.quotationId)
      },
    },
  }

</script>

